module.exports = __webpack_public_path__ + "media/images/solutions-analytics-supporting-2-4778106f97f74da6bdf38e3bfdac7e21.svg";